import orchestratorIcon from "./../assets/productIcons/orchestrator.png"
import actionCenterIcon from "./../assets/productIcons/actioncenter.png"
import aiCenterIcon from "./../assets/productIcons/aIcenter.png"
import appsIcon from "./../assets/productIcons/apps.png"
import automationHubIcon from "./../assets/productIcons/automationhub.png"
import automationOpsIcon from "./../assets/productIcons/automationops.png"
import integrationServicesIcon from "./../assets/productIcons/integrationservices.png"
import studioWebIcon from "./../assets/productIcons/studioweb.png"
import dataServiceIcon from "./../assets/productIcons/dataservice.png"
import duIcon from "./../assets/productIcons/du.png"
import insightsIcon from "./../assets/productIcons/insights.png"
import processMiningIcon from "./../assets/productIcons/processmining.png"
import testManagerIcon from "./../assets/productIcons/testmanager.png"
// Note: AITL icon needs to be added - using orchestrator icon as placeholder
import aitlIcon from "./../assets/productIcons/orchestrator.png"
// Note: A4E icon needs to be added - using orchestrator icon as placeholder
import a4eIcon from "./../assets/productIcons/orchestrator.png"
// Note: Automation Solutions icon needs to be added - using orchestrator icon as placeholder
import automationSolutionsIcon from "./../assets/productIcons/orchestrator.png"
// Note: Agent Hub icon needs to be added - using orchestrator icon as placeholder
import agentHubIcon from "./../assets/productIcons/orchestrator.png"
// Note: A4D icon needs to be added - using orchestrator icon as placeholder
import a4dIcon from "./../assets/productIcons/orchestrator.png"
// Note: Agents icon needs to be added - using orchestrator icon as placeholder
import agentsIcon from "./../assets/productIcons/orchestrator.png"
// Note: Maestro icon needs to be added - using orchestrator icon as placeholder
import maestroIcon from "./../assets/productIcons/orchestrator.png"
// Note: Semantic Proxy icon needs to be added - using orchestrator icon as placeholder
import semanticProxyIcon from "./../assets/productIcons/orchestrator.png"
// Note: Computer Vision icon needs to be added - using orchestrator icon as placeholder
import computerVisionIcon from "./../assets/productIcons/orchestrator.png"


export const ICONS =new Map<string, any>([
    ['platform', orchestratorIcon],
    ['orchestrator', orchestratorIcon],
    ['action_center', actionCenterIcon],
    ['apps', appsIcon],
    ['ai_center', aiCenterIcon],
    ['automation_hub', automationHubIcon],
    ['document_understanding_ai_center', duIcon],
    ['document_understanding_modern_projects', duIcon],
    ['insights', insightsIcon],
    ['automation_ops', automationOpsIcon],
    ['test_manager', testManagerIcon],
    ['data_service', dataServiceIcon],
    ['process_mining', processMiningIcon],
    ['automation_suite_robots', orchestratorIcon],
    ['integration_services', integrationServicesIcon],
    ['studio_web', studioWebIcon],
    ['aitl', aitlIcon],
    ['a4e', a4eIcon],
    ['automation_solutions', automationSolutionsIcon],
    ['agent_hub', agentHubIcon],
    ['a4d', a4dIcon],
    ['agents', agentsIcon],
    ['maestro', maestroIcon],
    ['semantic_proxy', semanticProxyIcon],
    ['computer_vision', computerVisionIcon]
])

export const PLATFORM_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Shared Suite Capabilities",
  key: "platform",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const ORCHESTRATOR_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Orchestrator",
  key: "orchestrator",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const ACTION_CENTER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Action Center",
  key: "action_center",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const BUSINESS_APPS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Apps",
  key: "apps",
  profile: "lite",
  isCoreProduct: 0,
  isStartingProduct: 0,
  properties: {},
};
export const AI_CENTER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "AI Center",
  key: "ai_center",
  profile: "lite",
  isCoreProduct: 0,
  isStartingProduct: 0,
  properties: {},
};

export const AUTOMATION_HUB_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Automation Hub",
  key: "automation_hub",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const DOCUMENT_UNDERSTANDING_AI_CENTER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Document Understanding - AI Center",
  key: "document_understanding_ai_center",
  profile: "lite",
  isCoreProduct: 0,
  isStartingProduct: 0,
  properties: {},
};

export const DOCUMENT_UNDERSTANDING_MODERN_PROJECTS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Document Understanding - Modern Projects",
  key: "document_understanding_modern_projects",
  profile: "lite",
  isCoreProduct: 0,
  isStartingProduct: 0,
  properties: {
    isModernProjectsEnabled: true,
    cpuInference: false,
    extendedOcr: false,
  },
};

export const INSIGHTS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Insights",
  key: "insights",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const AUTOMATION_OPS_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Automation Ops",
  key: "automation_ops",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const TEST_MANAGER_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Test Manager",
  key: "test_manager",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const DATA_SERVICE_PRODUCT_OPTION: ProductOptionInterface = {
  name: "Data Service",
  key: "data_service",
  profile: "lite",
  isCoreProduct: 1,
  isStartingProduct: 1,
  properties: {},
};

export const PROCESS_MINING_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Process Mining",
    key: "process_mining",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {
        modelBasedApplications: false,
        postgresEnabled: true,
    },
};

export const AUTOMATION_SUITE_ROBOTS_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Automation Suite Robots",
    key: "automation_suite_robots",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};
export const INTEGRATION_SERVICES_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Integration Services",
    key: "integration_services",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};
export const STUDIO_WEB_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Studio Web",
    key: "studio_web",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const AITL_PRODUCT_OPTION: ProductOptionInterface = {
    name: "AITL (LLM Gateway, LLM Observability, Context Grounding)",
    key: "aitl",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const A4E_PRODUCT_OPTION: ProductOptionInterface = {
    // Renamed from "Autopilot for Everyone" in 2026.10; the key stays `a4e`
    // so shared calculator URLs keep resolving.
    name: "Conversational Agents Service",
    key: "a4e",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const AUTOMATION_SOLUTIONS_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Automation Solutions",
    key: "automation_solutions",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const AGENT_HUB_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Agent Hub",
    key: "agent_hub",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const A4D_PRODUCT_OPTION: ProductOptionInterface = {
    name: "A4D",
    key: "a4d",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const AGENTS_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Agents",
    key: "agents",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const MAESTRO_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Maestro",
    key: "maestro",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const SEMANTIC_PROXY_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Semantic Proxy",
    key: "semantic_proxy",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const COMPUTER_VISION_PRODUCT_OPTION: ProductOptionInterface = {
    name: "Computer Vision",
    key: "computer_vision",
    profile: "lite",
    isCoreProduct: 0,
    isStartingProduct: 0,
    properties: {},
};

export const ALL_PRODUCT_OPTIONS = [
  PLATFORM_PRODUCT_OPTION,
  ORCHESTRATOR_PRODUCT_OPTION,
  ACTION_CENTER_PRODUCT_OPTION,
  BUSINESS_APPS_PRODUCT_OPTION,
  AI_CENTER_PRODUCT_OPTION,
  AUTOMATION_HUB_PRODUCT_OPTION,
  DOCUMENT_UNDERSTANDING_AI_CENTER_PRODUCT_OPTION,
  DOCUMENT_UNDERSTANDING_MODERN_PROJECTS_PRODUCT_OPTION,
  INSIGHTS_PRODUCT_OPTION,
  AUTOMATION_OPS_PRODUCT_OPTION,
  TEST_MANAGER_PRODUCT_OPTION,
  DATA_SERVICE_PRODUCT_OPTION,
  PROCESS_MINING_PRODUCT_OPTION,
  AUTOMATION_SUITE_ROBOTS_PRODUCT_OPTION,
  INTEGRATION_SERVICES_PRODUCT_OPTION,
  STUDIO_WEB_PRODUCT_OPTION,
  AITL_PRODUCT_OPTION,
  A4E_PRODUCT_OPTION,
  AUTOMATION_SOLUTIONS_PRODUCT_OPTION,
  AGENT_HUB_PRODUCT_OPTION,
  A4D_PRODUCT_OPTION,
  AGENTS_PRODUCT_OPTION,
  MAESTRO_PRODUCT_OPTION,
  SEMANTIC_PROXY_PRODUCT_OPTION,
  COMPUTER_VISION_PRODUCT_OPTION
];

export const CORE_PRODUCT_OPTIONS = ALL_PRODUCT_OPTIONS.filter(
  (option) => !!option.isCoreProduct
);

export const STARTING_PRODUCT_OPTIONS = ALL_PRODUCT_OPTIONS.filter(
  (option) => !!option.isStartingProduct
);

// Builds the "Learn more" documentation links shown in product details.
// Standard URL pattern: https://docs.uipath.com/<slug>/automation-suite/latest
// where <slug> is the product key with underscores replaced by hyphens.
// Use the override maps below when a product doesn't follow this pattern.
// To add a new product: add its key to PRODUCTS_WITH_DOCS.
const AS_DOCS_BASE = "https://docs.uipath.com";

// Products with a documentation link. Anything not listed shows no link.
const PRODUCTS_WITH_DOCS: readonly string[] = [
  "orchestrator",
  "action_center",
  "apps",
  "ai_center",
  "document_understanding_ai_center",
  "document_understanding_modern_projects",
  "data_service",
  "process_mining",
  "integration_services",
  "studio_web",
  "agents",
  "maestro",
  "automation_hub",
  "a4e",
  "automation_ops",
  "insights",
  "test_manager",
  "automation_solutions",
  "automation_suite_robots",
  "aitl",
  "computer_vision",
];

// Slug overrides for products whose docs.uipath.com name differs from the
// key. e.g. "integration_services" → "integration-service" (singular).
// Both DU variants share the same docs page.
const PRODUCT_DOC_SLUG_OVERRIDES: Record<string, string> = {
  document_understanding_ai_center: "document-understanding",
  document_understanding_modern_projects: "document-understanding",
  integration_services: "integration-service",
  a4e: "autopilot",
  automation_solutions: "solutions-management",
};

// Full-URL overrides for products without a top-level "latest" docs page —
// their docs live under deeper paths. The version (e.g. "2.2510") is
// hard-coded and must be bumped on each AS release.
const PRODUCT_DOC_URL_OVERRIDES: Record<string, string> = {
  automation_suite_robots: `${AS_DOCS_BASE}/orchestrator/automation-suite/2.2610/user-guide/about-automation-suite-robots`,
  aitl: `${AS_DOCS_BASE}/automation-suite/automation-suite/2.2610/admin-guide/about-ai-trust-layer`,
  computer_vision: `${AS_DOCS_BASE}/ai-computer-vision/automation-suite/2.2610`,
};

export const PRODUCT_DOC_URLS: Record<string, string> = Object.fromEntries(
  PRODUCTS_WITH_DOCS.map((key) => {
    if (PRODUCT_DOC_URL_OVERRIDES[key]) return [key, PRODUCT_DOC_URL_OVERRIDES[key]];
    const slug = PRODUCT_DOC_SLUG_OVERRIDES[key] ?? key.replace(/_/g, "-");
    return [key, `${AS_DOCS_BASE}/${slug}/automation-suite/latest`];
  })
);


export const OCR_REPLICAS = "OCR";
export const CUSTOM_MODEL_TRAINING_REPLICAS = "Custom model training";
export const CUSTOM_MODEL_REPLICAS = "Custom model"
export const OOB_MODEL_REPLICAS = "OOB model"

export const POSTGRESS_ENABLED = "postgresEnabled";

// AS Version options for the version dropdown
// Pls update version list for all current supported versions to have latest LTS versions , eg -> 2022-10 should have list upto latest LTS i.e 2025-10 .
// `value` is the URL segment used by the calculator app
// (https://docs.uipath.com/automation-suite/<value>/calculator).
// `label` is the user-facing version name — UiPath switched from YYYY.MM to
// the 2.YYMM scheme starting with 2025.10 (labeled "2.2510").
export const AS_VERSION_OPTIONS = [
  { value: "2022.10", label: "2022.10" },
  { value: "2023.4", label: "2023.4" },
  { value: "2023.10", label: "2023.10" },
  { value: "2024.10", label: "2024.10" },
  { value: "2025.10", label: "2.2510" },
  { value: "2026.10", label: "2.2610" },
];

export const DEFAULT_AS_VERSION = "2026.10";

const AS_CALCULATOR_BASE_URL = "https://docs.uipath.com/automation-suite";

export const getCalculatorUrlForVersion = (version: string): string => {
  const safeVersion = AS_VERSION_OPTIONS.some((opt) => opt.value === version)
    ? version
    : DEFAULT_AS_VERSION;
  return `${AS_CALCULATOR_BASE_URL}/${safeVersion}/calculator`;
};

// Function to get current version from URL
export const getCurrentVersionFromUrl = (): string => {
  // Matches /YYYY.M/ or /YYYY.MM/ — minor can be 1-2 digits (e.g. 2023.4).
  const path = window.location.pathname;
  const versionMatch = path.match(/\/(\d{4}\.\d{1,2})(?:\/|$)/);
  return versionMatch ? versionMatch[1] : DEFAULT_AS_VERSION;
};
